import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { get } from 'lodash'

import { Select, Checkbox } from 'components/fields'
import { Button } from 'components/misc'
import { form } from 'helpers/decorators'
import { availableContactsDropdownSelector } from 'redux/selectors/contacts'

const enhance = compose(
  form({
    form: 'add-coordinator'
  })
)

class CoordinatorAdd extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onContactChange: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    dropdownOrganizationContacts: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    values: PropTypes.object,
    organizationId: PropTypes.number,
    submitting: PropTypes.bool
  }

  render() {
    const {
      handleSubmit,
      dropdownOrganizationContacts,
      data,
      values,
      organizationId,
      submitting
    } = this.props

    const availableOrganizationContacts = availableContactsDropdownSelector(
      dropdownOrganizationContacts,
      data
    )

    return (
      <form
        onSubmit={handleSubmit(fields =>
          this.props.onContactChange(organizationId, fields)
        )}
      >
        <Select
          label="Organization contact"
          name="contactId"
          intlKey="label.organization_contact"
          options={availableOrganizationContacts}
          searchable
        />
        <Checkbox
          label="Make as lead coordinator"
          intlKey="label.make_as_lead_coordinator"
          name="is_lead_coordinator"
          disabled={!get(values, 'contactId')}
        />
        <div className="row">
          <div className="col-xs-6">
            <Button
              type="button"
              secondary
              onClick={this.props.onClose}
              intlKey="button.close"
            >
              Close
            </Button>
          </div>
          <div className="col-xs-6 text--right">
            <Button isLoading={submitting} intlKey="button.add">Add</Button>
          </div>
        </div>
      </form>
    )
  }
}

export default enhance(CoordinatorAdd)
